<template>
  <div class="version-container">
    <div class="flex gap-2" style="text-align: left; ">
    <el-tag type="primary" @click="toggleNewestMsg" >
    目前同步進度 <el-icon><CaretBottom v-if="!showNewestMsg" /><CaretTop v-else /></el-icon>
    </el-tag>
    </div>
    <div v-if="showNewestMsg">
      <el-link :href="newestBulletinLink" target="_blank">{{ newestModerator }} {{ newestDate }} {{ newestAid }}</el-link>
    </div>
  </div>
  <el-form :inline="true">
    <el-form-item label="帳號"  required>
      <el-input v-model="userId" placeholder="請輸入帳號" :clearable="true" style="width: 200px;"></el-input>     
    </el-form-item>
    <el-form-item>
      <el-button type="primary" size="default" @click="query" >查詢</el-button>
    </el-form-item>
  </el-form>


  <div class="table-container">
    <el-table :data="violationDatas"  v-if="violationDatas.length>0" >
      <el-table-column prop="date" label="日期" />
      <el-table-column label="文章代碼" >
        <template #default="{ row }">
          <el-link :href="row.BulletinLink" target="_blank">{{ row.aid }}</el-link>
        </template>
      </el-table-column>  
      <el-table-column prop="ViolationRule" label="違反板規" />
      <el-table-column prop="Punish" label="處置方式" />
    </el-table>
    <div style="margin-top: 30px;"></div>
    
    <div v-if="violationDatas.length>0" >
      <el-switch v-model="addHeader" /><el-text class="mx-1" size="small">增加「違規紀錄：」</el-text><br />
      <el-button type="warning" @click="copyTableData" v-if="violationDatas.length>0"><el-icon><DocumentCopy /></el-icon> 複製到剪貼簿</el-button>
    </div>
    
    <el-text class="mx-1" type="info">{{ notFoundMsg }}</el-text>
  </div> 
</template>


<script setup >
import {  onMounted, ref } from 'vue';
import initSqlJs from 'sql.js';
import { ElMessage } from 'element-plus';
import { CaretTop, CaretBottom, DocumentCopy } from '@element-plus/icons-vue';

//const initSqlJs = require('sql.js');
//const initSqlJs = window.initSqlJs;

const userId = ref('');
const violationDatas = ref([]);
const notFoundMsg = ref();

const showNewestMsg = ref(false);

const addHeader = ref(true);

let SQL, db;
onMounted(async ()=>{
  SQL = await initSqlJs({
  // Required to load the wasm binary asynchronously. Of course, you can host it wherever you want
  // You can omit locateFile completely when running in node
  locateFile: file => `/sql-wasm.wasm`
  });

  const response = await fetch('/css/style.css');
  const data = await response.arrayBuffer();
  //const db = new SQL.Database(new Uint8Array(data));
  db = new SQL.Database(new Uint8Array(data));
  getNewest();
});

const newestDate = ref();
const newestAid = ref();
const newestModerator = ref();
const newestBulletinLink = ref();

const getNewest = () => {
  if (!db) {
    alert('Database not initialized.');
    return;
  }

  try {
    const stmt = db.prepare("SELECT YEAR || '/' || BulletinDate as date, AID || ' (Stock)' as aid, Moderator, BulletinLink FROM ViolationRecords WHERE Change is null  order by BulletinLink desc  limit 1 ");
    stmt.step();
    const result = stmt.getAsObject();

    newestDate.value = result.date; // 获取 'date' 字段的值
    newestAid.value = result.aid;   // 获取 'aid' 字段的值
    newestBulletinLink.value = result.BulletinLink; 
    newestModerator.value = result.Moderator;

  } catch(error)  {
    console.error('Query failed:', error);
  }
}


const query = () => {
  if (!db) {
    alert('Database not initialized.');
    return;
  }

  userId.value = userId.value.trim();

  if(!userId.value){
    ElMessage({type: 'error', message: '請輸入帳號'})
    return;
  }

  try {
    const stmt = db.prepare("SELECT YEAR || '/' || BulletinDate as date, AID || ' (Stock)' as aid, ViolationRule, Punish, BulletinLink FROM ViolationRecords WHERE userId = :userId COLLATE NOCASE AND Change is null order by date ");
    //const result = stmt.getAsObject({':userId' : userId.value});
    stmt.bind({ ':userId': userId.value });
    const results = [];
    while (stmt.step()) {
      results.push(stmt.getAsObject());
    }    
    
    violationDatas.value = [];
    notFoundMsg.value = '';

    if(results.length > 0) {
      violationDatas.value = results;
    } else{
      notFoundMsg.value = '查無水桶公告紀錄 (有可能只是刪文 板主沒公告 可在檢舉板搜尋)';
    }

  } catch (error) {
    console.error('Query failed:', error);
  }
};

const toggleNewestMsg = () => {
  showNewestMsg.value = !showNewestMsg.value;
}

const copyTableData = () => {
  const visibleColumns = ['date', 'aid', 'ViolationRule', 'Punish'];

  // 将表格数据转换为字符串
  const csvContent = violationDatas.value.map(row => 
    visibleColumns.map(col => row[col]).join('\t')
  ).join('\n');

  var header = "";
  if(addHeader.value) {
    header = "違規紀錄：";
  }  
  
  // 创建一个隐藏的文本区域来执行复制操作
  const textarea = document.createElement('textarea');
  textarea.value = header + '\n' + csvContent;
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('copy');
  document.body.removeChild(textarea);

  // 可以提示用户复制成功
  ElMessage({type: 'success', message: '已複製到剪貼簿'})

}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.version-container {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 1000; /* Ensure it stays on top */
}

.table-container {
  width: 100%;
  max-width: 1200px; /* Max width for larger screens */
  margin: 0 auto;
  padding: 0 10px; /* Optional padding for mobile */
  box-sizing: border-box;
}

.el-table {
  width: 100%;
  overflow-x: auto; /* Add horizontal scroll on small screens */
}

/* Media query for small screens */
@media (max-width: 768px) {
  .el-table {
    font-size: 12px; /* Reduce font size for better readability on smaller screens */
  }

  .el-table-column {
    width: auto; /* Let columns adjust their width automatically */
  }
}

.el-link {
  margin-right: 8px;
}
.el-link .el-icon--right.el-icon {
  vertical-align: text-bottom;
}
</style>
